import type { DialerSource } from "@gioia365/contracts";
import { useQueries } from "@tanstack/react-query";
import { leadOwnerOptionsQuery } from "../leads/lead-queries";
import type { TabContext } from "../session/tab-context";
import type { SourcePeople } from "./dialer-texts";

// Chi sono le persone nel nome di una sorgente dei Task (piano M5, Task 21): la barra, il riepilogo e la finestra «Hai una cascata in
// corso su …» dicono «Task «Oggi» · Luca Verdi». La sessione porta l'identificativo della persona e non il nome; il nome è quello delle
// persone di «Di chi» (la stessa lettura, in cache). Si legge soltanto per la cascata di un collega: quella di tutto il team e le
// proprie non ne hanno bisogno, e allora nessuna lettura nasce (neanche spenta: la cache non ne tiene).

/** Le persone di «Di chi» per nominare `source` (`null`: nessuna sorgente da nominare) sulla scheda `tab` (`null`: nessuna scheda). */
export function useSourcePeople(tab: TabContext | null, source: DialerSource | null): SourcePeople {
  const me = tab?.kind === "membership" ? tab.membershipId : null;
  const colleague = source !== null && source.type === "task_view" && source.who !== "all" && source.who !== me;
  const queries: Array<ReturnType<typeof leadOwnerOptionsQuery>> = tab !== null && colleague ? [leadOwnerOptionsQuery(tab)] : [];
  const [people] = useQueries({ queries });
  return { me, nameOf: (membershipId) => people?.data?.find((person) => person.membershipId === membershipId)?.displayName };
}
